/** FNV-1a 32-bit, used to compare game states across browsers. */
export const FNV_OFFSET = 0x811c9dc5;
const FNV_PRIME = 0x01000193;

export function fnv1aBytes(hash: number, data: Uint8Array): number {
  let h = hash;
  for (let i = 0; i < data.length; i++) {
    h ^= data[i];
    h = Math.imul(h, FNV_PRIME);
  }
  return h >>> 0;
}

/** Mixes the 4 bytes of a 32-bit integer (little-endian). */
export function fnv1aInt(hash: number, value: number): number {
  let h = hash;
  const v = value | 0;
  h ^= v & 0xff;
  h = Math.imul(h, FNV_PRIME);
  h ^= (v >>> 8) & 0xff;
  h = Math.imul(h, FNV_PRIME);
  h ^= (v >>> 16) & 0xff;
  h = Math.imul(h, FNV_PRIME);
  h ^= (v >>> 24) & 0xff;
  h = Math.imul(h, FNV_PRIME);
  return h >>> 0;
}
